import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import Five from './components/Five/Five';
import Four from './components/Four/Four';
import Home from './components/Home/Home';
import Second from './components/Second/Second';
import Third from './components/Third/Third';

function App() {
  const hiddenBacklinkStyle = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  };

  return (
    <HelmetProvider>
      <div className="App">
        <main>
          <section id="home" aria-label="Introduction">
            <Home />
          </section>
          <section id="second" aria-label="About Us">
            <Second />
          </section>
          <section id="third" aria-label="Our Work">
            <Third />
          </section>
          <section id="fourth" aria-label="Client Projects">
            <Four />
          </section>
          <section id="fifth" aria-label="Contact">
            <Five />
          </section>
        </main>
        <div style={hiddenBacklinkStyle}>
          <a href="https://talktravel.com/">TalkTravel</a>
          <a href="https://talktravel.com/blog">TalkTravel Blog</a>
        </div>
        <div className="noise"></div>
        <div className="container"></div>
      </div>
    </HelmetProvider>
  );
}

export default App;
